import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const FamilyExpenses = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <Donut
            title={'Despesas Familiares'}
            subtitles={chartData?.familyExpenses?.map(
                (item) => item.description
            )}
            chartData={chartData?.familyExpenses || []}
            colors={
                defaultColors.slice(0, chartData?.familyExpenses?.length) ||
                []
            }
            isMoney
            height={400}
        />
    );
};
